import gql from 'graphql-tag'

export const UPDATE_BRAND_PROFILE = gql`
  mutation UpdateBrandProfile($brandUuid: ID!, $brandUpdateInput: BrandUpdateInput!) {
    updateBrandProfile(brandUuid: $brandUuid, brandUpdateInput: $brandUpdateInput) {
      uuid
      tradingName
      website
      avatar {
        cloudinaryId
        cloudinaryType
      }
      industries {
        uuid
        name
      }
      city {
        uuid
        name
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/UpdateBrandProfile.tsx